import axios from "axios";
import { forceLogout } from "@/helpers/force-logout";

// const accessToken = Cookies.get(authConfig.ACCESS_TOKEN_COOKIE);
const baseURL =
  process.env.VUE_APP_EXAM_API_BASE_URL || "http://localhost:9797/api";

const client = axios.create({
  baseURL: baseURL,
  headers: {
    Accept: "application/json",
    Authorization: `${localStorage.getItem("token")}`
  }
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    // If unauthorized, force logout and route to login page
    if (error.response && error.response.status === 401) {
      forceLogout();
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

export default {
  async get(endpoint, params = {}) {
    client.defaults.headers.common["ComId"] = localStorage.getItem("ComId");
    return await client.get(`${endpoint}`, params);
  },

  async post(endpoint, payloads = {}) {
    client.defaults.headers.common["ComId"] = localStorage.getItem("ComId");
    return await client.post(`${endpoint}`, payloads);
  },

  async put(endpoint, payloads = {}) {
    client.defaults.headers.common["ComId"] = localStorage.getItem("ComId");
    return await client.put(`${endpoint}`, payloads);
  },

  async patch(endpoint, payloads = {}) {
    client.defaults.headers.common["ComId"] = localStorage.getItem("ComId");
    return await client.patch(`${endpoint}`, payloads);
  },

  async delete(endpoint, payloads = {}) {
    client.defaults.headers.common["ComId"] = localStorage.getItem("ComId");
    return await client.delete(`${endpoint}`, { data: payloads });
  }
};
